import { Split } from 'lucide-react';

import { getChoiceGroupProgress, getChoiceGroupTotal } from '../../../utils/choiceGroups';

/**
 * Tells the student they are inside an "attempt any X of these Y" block.
 *
 * Nothing here restricts them: they may answer every question in the group, and the best X
 * answers are the ones that count. The banner exists so that is not a surprise — a student
 * who does not know only two of three count would either waste time or leave marks behind.
 */
const ChoiceGroupBanner = ({ group, studentResponse, assignment }) => {
  if (!group) return null;

  const { answered, requiredCount, total, remaining, isSatisfied } = getChoiceGroupProgress(
    group,
    studentResponse,
    assignment
  );
  const marks = getChoiceGroupTotal(group);

  return (
    <div className="mb-4 rounded-lg border border-purple-200 bg-purple-50 px-3 py-2.5">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <Split className="h-4 w-4 flex-shrink-0 text-purple-600" />
          <span className="text-sm font-medium text-purple-900">
            Attempt any {requiredCount} of {total}
          </span>
          {group.name ? (
            <span className="truncate text-xs text-purple-800/70">{group.name}</span>
          ) : null}
        </div>

        <span
          className={`whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${
            isSatisfied ? 'bg-green-100 text-green-800' : 'bg-white text-purple-800'
          }`}
        >
          {isSatisfied
            ? `${answered} answered`
            : `${answered} of ${requiredCount} answered`}
        </span>
      </div>

      <p className="mt-1.5 text-xs text-purple-800/80">
        {isSatisfied
          ? `You can still answer the others — your best ${requiredCount} count towards the ${marks} marks.`
          : `Answer ${remaining} more from this set. You may answer all ${total}; your best ${requiredCount} count towards the ${marks} marks.`}
      </p>
    </div>
  );
};

export default ChoiceGroupBanner;
